<template>
  <div class="tech-page-content">
    <banner>
      <p>打造自有知识产权核心技术<br/>
        以科技驱动发展</p>
    </banner>

    <div class="tec-list">
      <!--生物识别-->
      <div class="panel-main tec-list-item bio">
        <div class="panel-content">
          <div class="public-layout-table2">
            <div class="panel-item">
              <img src="../../static/images/technology/tec-bio.jpg" alt="" />
            </div>
            <div class="panel-item">
              <dl class="tec-info-sheet">
                <dt subtitle="Biometrics">生物识别</dt>
                <dd>
                  我们应用目前学术界最前沿的基于深度学习理论的生物识别技术，尤其在人脸识别、指纹识别、指静脉识别领域进行了行业应用的优化，实现快速、精准的身份识别和资格认证。广泛应用于人社、安防、金融等领域。
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      <!--自然语言处理-->
      <div class="panel-main tec-list-item nature-lang">
        <div class="panel-content">
          <div class="public-layout-table2">
            <div class="panel-item">
              <dl class="tec-info-sheet">
                <dt subtitle="Natural language">自然语言处理</dt>
                <dd>
                  我们依托机器学习和行业海量数据积累，定义行业语义模型，识别和理解自然语言，达到用户与系统进行自然交互的效果。被广泛应用于人社公共服务智能问答领域。
                </dd>
              </dl>
            </div>
            <div class="panel-item">
              <img src="../../static/images/technology/tec-lang.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>

      <!--深度学习技术-->
      <div class="panel-main tec-list-item deep-study">
        <div class="panel-content">
          <div class="public-layout-table2">
            <div class="panel-item">
              <img src="../../static/images/technology/tec-study.jpg" alt="" />
            </div>
            <div class="panel-item">
              <dl class="tec-info-sheet">
                <dt subtitle="Deep learning">深度学习 </dt>
                <dd>
                  我们应用多层神经网络的机器学习算法，处理图像、文本、语言等非结构化数据，形成生物识别、知识检索、语义理解等算法，并支持算法的持续改善，支撑各类应用能力的持续提升。
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      <!--知识图谱技术-->
      <div class="panel-main tec-list-item know-grahp">
        <div class="panel-content">
          <div class="public-layout-table2">
            <div class="panel-item">
              <dl class="tec-info-sheet">
                <dt subtitle="Knowledge Graph">知识图谱</dt>
                <dd>
                  我们通过对行业知识的分析，把复杂的知识通过数据挖掘、信息处理、知识计量和图形绘制而显示出来，揭示知识之间的关联关系及动态发展规律。应用于智能知识库领域以提升知识生成的智能化水平。
                </dd>
              </dl>
            </div>
            <div class="panel-item">
              <img src="../../static/images/technology/tec-know.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>

      <!--智能大数据-->
      <div class="panel-main tec-list-item big-data">
        <div class="panel-content">
          <div class="public-layout-table2">
            <div class="panel-item">
              <img src="../../static/images/technology/tech-data.jpg" alt="" />
            </div>
            <div class="panel-item">
              <dl class="tec-info-sheet">
                <dt subtitle="Big Data">智能大数据 </dt>
                <dd>
                  我们从各种结构化和非结构化数据源中筛选信息，深度分析发掘数据间关系，帮助用户改善认知过程，应用于智能推荐及“三医联动”新局面下的数据服务产品。
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import HeaderBar from '../components/HeaderBar'
  import FooterBar from '../components/FooterBar'
  import Banner from '../components/Banner'

  export default {
    data () {
      return { }
    },
    methods: {

    },
    components: {
      HeaderBar,
      FooterBar,
      Banner
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .tech-page-content {
    .pulic-banner-container{
      background-image: url('../assets/images/banners/bg-tech.jpg');
    }
    /*每行的文字样式*/
    .tec-info-sheet{
      width: 440px;
      dt{
        font-size: 20px;
        color: #3ebcf0;
        font-weight: bold;
        position: relative;
        z-index: 1;
        margin-bottom: 3em;
        &:before{
          content: attr(subtitle);
          color: inherit;
          position: absolute;
          bottom: -1.6em;
          font-weight: lighter;
          font-size: 18px;
        }
        &:after{
          content: ' ';
          display: block;
          width: 61px;
          height: 0;
          border-bottom: 1px solid #3ebcf0;
          position: absolute;
          bottom: -1.8em;
        }
      }
      dd{
        color: #3a3a3a;
        font-size: 14px;
        line-height: 1.8em;
      }
    }
    /*2列布局定制样式*/
    .public-layout-table2{
      padding-top: 80px;
      .panel-item{
        &:first-child{
          position: relative;
          z-index: 5;
        }
        &:last-child{
          position: relative;
          z-index: 4;
        }
        img{
          display: block;
          width: 100%;
        }
      }
    }
    /*2列布局针对行定制样式*/
    .tec-list-item{
      &:nth-child(odd){
        .panel-item:first-child{
          position: relative;
          width: 53.45%;
        }
        .panel-item:last-child{
          width: 46.55%;
          margin-top: 62px;
        }
        .tec-info-sheet{
          /*margin-top: 60px;*/
          margin-left: 38px;
        }
      }
      &:nth-child(even){
        .panel-item:first-child{
          width: 46.55%;
        }
        .panel-item:last-child{
          width: 53.45%;
        }
        .tec-info-sheet{
          margin-top: 38px;
          margin-left: 38px;
        }
      }
      /*生物识别*/
      &.bio{
        background: #f4f4f4;
        .public-layout-table2{
          margin-bottom: 0;
        }
      }
      /*自然语言*/
      &.nature-lang{
        background: #f4f4f4;
        padding-bottom: 60px;
        .tec-info-sheet{
          margin-top: 40px;
          margin-left: 28px;
          width: 410px;
        }
        .public-layout-table2{
          padding-top: 40px;
        }
      }
      /*深度学习技术*/
      &.deep-study{
        background: #fff;
        .public-layout-table2{
          padding-top: 60px;
          padding-bottom: 60px;
          .panel-item:last-child{
            margin-top: 0;
            .tec-info-sheet{
              /*width: 385px;*/
              margin-top: 62px;
              padding-bottom: 95px;
            }
          }
        }
      }

      /*知识图谱技术*/
      &.know-grahp{
        background: #f4f4f4;
        .public-layout-table2{
          padding-top: 60px;
        }
      }

      /*智能大数据*/
      &.big-data{
        background: #f4f4f4;
        .public-layout-table2{
          padding-top: 60px;
          padding-bottom: 60px;
        }
        .tec-info-sheet{
          margin-top: 68px!important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pc/Technology.vue